import { updateCategory } from "@wordpress/blocks";
import CategoryIcon from "./icon";

updateCategory("essential-blocks", { icon: CategoryIcon });
